// ============================================================================
// Barrel for shared RxDB collection schemas + replication protocol types.
//
// Imported by both the backend route handler (apps/backend/src/routes/rxdb.ts)
// and the frontend RxDB layer (apps/frontend/src/services/rxdb/).
// ============================================================================

export * from './protocol';
export * from './migration';
export * from './diaryDays';
export * from './diaryDayOutbox';
export * from './recipes';
export * from './userFoods';
export * from './goalsHistory';
export * from './weightHistory';
export * from './customFoodMigrations';
export * from './settings';
export * from './meals';
export * from './reviewNotes';
export * from './coachPlans';

export type {
  DiaryDayDocType,
  RecipeDocType,
  UserFoodDocType,
  GoalHistoryDocType,
  WeightHistoryDocType,
  CustomFoodMigrationDocType,
  SettingDocType,
  MealsConfigurationDocType,
  ReviewNoteDocType,
  CoachPlanDocType,
} from '../validators';

import { CUSTOM_FOOD_MIGRATIONS_COLLECTION, customFoodMigrationsModel } from './customFoodMigrations';
import { DIARY_DAYS_COLLECTION, diaryDaysModel } from './diaryDays';
import { DIARY_DAY_OUTBOX_COLLECTION, diaryDayOutboxModel } from './diaryDayOutbox';
import { GOALS_HISTORY_COLLECTION, goalsHistoryModel } from './goalsHistory';
import { MEALS_COLLECTION, mealsModel } from './meals';
import { RECIPES_COLLECTION, recipesModel } from './recipes';
import { SETTINGS_COLLECTION, settingsModel } from './settings';
import { USER_FOODS_COLLECTION, userFoodsModel } from './userFoods';
import { WEIGHT_HISTORY_COLLECTION, weightHistoryModel } from './weightHistory';
import { REVIEW_NOTES_COLLECTION, reviewNotesModel } from './reviewNotes';
import { COACH_PLANS_COLLECTION, coachPlansModel } from './coachPlans';

export const rxdbModels = {
  [DIARY_DAYS_COLLECTION]: diaryDaysModel,
  [DIARY_DAY_OUTBOX_COLLECTION]: diaryDayOutboxModel,
  [RECIPES_COLLECTION]: recipesModel,
  [USER_FOODS_COLLECTION]: userFoodsModel,
  [GOALS_HISTORY_COLLECTION]: goalsHistoryModel,
  [WEIGHT_HISTORY_COLLECTION]: weightHistoryModel,
  [CUSTOM_FOOD_MIGRATIONS_COLLECTION]: customFoodMigrationsModel,
  [SETTINGS_COLLECTION]: settingsModel,
  [MEALS_COLLECTION]: mealsModel,
  [REVIEW_NOTES_COLLECTION]: reviewNotesModel,
  [COACH_PLANS_COLLECTION]: coachPlansModel,
} as const;
